<template>
  <div class="w-100">
    <b-progress v-if="showBar" :value="value" class="bar-container"></b-progress>
    <LoadingSpinner />
    <router-view @loading-bar="handleLoadingBar" />
  </div>
</template>

<script>
import LoadingSpinner from "@/partials/spinner";

export default {
  name: "Viewtrail",
  components: {
    LoadingSpinner,
  },
  mounted() {
    this.checkPath();
    this.startTimer();
  },
  data: () => ({
    value: 0,
    showBar: false,
  }),
  methods: {
    checkPath() {
      if (
        this.$route.path.endsWith("/int") ||
        this.$route.path.includes("/ext")
      ) {
        this.showBar = true;
      }
    },
    startTimer() {
      let vm = this;
      let timer = setInterval(function () {
        vm.value += 2;
        if (vm.value >= 1500) clearInterval(timer);
      }, 300);
    },
    handleLoadingBar (value) {
      this.showBar = value;
    },
  },
};
</script>

<style lang="scss">
@import "assets/scss/index";
</style>
